



























































































































import { appModule } from "@/store/modules/app";
import { storeResume } from "@/store/modules/resume";
import { userModule } from "@/store/modules/user";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import storeBilling from "@/store/modules/Billing";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { storeDokter } from "@/store/modules/dokter";
import CardTindakan from "@/components/pemeriksaan/pelayanan/CardTindakan.vue";
import LockingRegister from "@/utility/LockingRegister";
import { storePasien } from "@/store/modules/pasien";
import CardModalAksesTindakan from "@/components/modal/CardModalAksesTindakan.vue";
import Billing from "@/services/Billing";

@Component({
  components: {
    CardTindakan,
    CardModalAksesTindakan
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class TindakanMedikPoliklinik extends Vue {
  @Prop() statusLock!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  modalAksesTindakan = false;
  disDiag = true;
  disTambah = true;
  disSaving = true;
  // dokter = {};
  timeShow = false;
  tglShow = false;
  maxDate = moment().format("YYYY-MM-DD");
  time = moment().format("HH:mm");
  tglIsi = moment().format("YYYY-MM-DD");
  jam = moment().format("HHmm");
  selisih = null;

  get tglIsiFormattedMomentjs() {
    return this.tglIsi ? moment(this.tglIsi).format("DD-MM-YYYY") : "";
  }
  get register(): any {
    return RegisterKunjungan.register;
  }
  get registerNo(): string | number | null {
    return this.register ? this.register.no : null;
  }
  get pasien(): any {
    return storePasien.identitasPasien;
  }
  get stateresume() {
    return storeResume.resume;
  }
  get stateuser() {
    return userModule.user;
  }
  get listDokter() {
    return storeDokter.listAll;
  }

  mounted() {
    // this.cekDokter();

    window.onbeforeunload = function() {
      LockingRegister.unlockRegister("klinik");
      return "";
    };
  }

  @Watch("registerNo", { immediate: true })
  onRegisterLoaded(no: string | number | null) {
    if (!no) return;

    if (this.statusLock == "1") {
      this.changeLock("1");
      return;
    }

    this.loadBilling();
  }

  loadBilling() {
    storeBilling.getTindakanbyReg(this.register.no);
    storeBilling.getDiagnosis(this.register.no);
    storeBilling.getProcedure(this.register.no);
    this.tindakanByDateTime();
  }
  formatTgl(date) {
    const [day, month, year] = date.split("-");
    return year + "-" + month + "-" + day;
  }
  // cekDokter() {
  //   if (this.stateresume[0] != null) {
  //     this.dokter = this.stateresume[0].dpjp;
  //   } else {
  //     this.dokter = this.register.dokter;
  //   }
  // }
  tindakanByDateTime() {
    if (!this.register) return;

    console.log("get tindakan jam: ", this.jam);
    const request = {
      reg: this.register.no,
      tgl: this.tglIsi,
      jam: this.jam,
      unit: this.stateuser.unit_id
    };
    storeBilling.getTindakanbyRequest(request);
  }
  selisihDate(satu, dua) {
    this.selisih = null;
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate: any = new Date(satu);
    const secondDate: any = new Date(dua);
    this.selisih = Math.round(Math.abs((firstDate - secondDate) / oneDay));
  }
  kodeAkses() {
    this.disDiag = false;
    this.disSaving = false;
    this.disTambah = false;
  }
  batalTindakan() {
    this.disDiag = true;
    this.disSaving = true;
    this.disTambah = true;
  }

  @Watch("statusLock")
  async changeLock(val) {
    this.time = moment().format("HH:mm");
    if (val == "1") {
      if (!this.register) return;

      this.loadBilling();

      const stsKasir = await this.getStatusKasir(this.register.no);

      if (stsKasir.status === 1) {
        if (this.register.dout != null) {
          this.disDiag = true;
          this.disSaving = true;
          this.disTambah = true;
          appModule.sendErrorAlert(
            "Pasien sudah dipulangkan tanggal " + this.register.dout
          );
        } else {
          const tgl = moment().format("YYYY-MM-DD");
          this.selisihDate(tgl, this.formatTgl(this.register.tgl));
          // if (this.selisih > 14) {
          //   appModule.sendErrorAlert(
          //     "Pasien masih terdaftar di tanggal " + this.register.tgl
          //   );
          //   this.disDiag = true;
          //   this.disSaving = true;
          //   this.disTambah = true;
          // } else {
          //   if (this.register.unit == this.stateuser.unit_id) {
          //     this.disDiag = false;
          //     this.disSaving = false;
          //     this.disTambah = false;
          //   } else {
          //     this.modalAksesTindakan = true;
          //   }
          // }
          if (this.register.unit >= "50") {
            // console.log("Ranap");
            if (this.register.unit == this.stateuser.unit_id) {
              this.disDiag = false;
              this.disSaving = false;
              this.disTambah = false;
            } else {
              this.modalAksesTindakan = true;
            }
          } else {
            // console.log("Ralan");
            if (this.selisih > 14) {
              appModule.sendErrorAlert(
                "Pasien masih terdaftar di tanggal " + this.register.tgl
              );
              this.disDiag = true;
              this.disSaving = true;
              this.disTambah = true;
            } else {
              if (this.register.unit == this.stateuser.unit_id) {
                this.disDiag = false;
                this.disSaving = false;
                this.disTambah = false;
              } else {
                this.modalAksesTindakan = true;
              }
            }
          }
        }
      } else {
        this.disDiag = true;
        this.disSaving = true;
        this.disTambah = true;
        appModule.sendErrorAlert(stsKasir.message);
      }

      console.log("ok");
    }
  }

  @Watch("time")
  changeTime(newVal: string) {
    if (newVal.length === 5 && this.validateTimeFormat(newVal)) {
      this.jam = this.time.substr(0, 2) + this.time.substr(3, 2);

      this.tindakanByDateTime();
    }
  }

  async setFinalBilling() {
    const final = await Billing.setStatusFinalKasir(
      this.register.no,
      1,
      this.stateuser.nama + " (emedika)"
    ).then(resp => {
      if (resp.status === 1) {
        this.disSaving = true;
        this.disTambah = true;
      }

      appModule.sendErrorAlert(resp.message);
    });

    return final;
  }

  async getStatusKasir(regId) {
    const resp = await Billing.getStatusBillingKasir(regId);

    return resp;
  }

  // @Watch("stateresume")
  // changeResume() {
  //   if (this.stateresume[0]) {
  //     this.dokter = this.stateresume[0]["user"];
  //   }
  // }

  batalPeriksa() {
    this.changeLock("1");
    this.disDiag = true;
    this.disSaving = true;
    this.disTambah = true;
  }

  invalidTime = false;

  timeRules = [
    value => !!value || "Jam tidak boleh kosong",
    value =>
      (value && this.validateTimeFormat(value)) || "Jam tidak sesuai format!"
  ];

  validateTimeFormat(timeStr: string) {
    const timeRegex = /^(0?[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/i;

    const match = timeStr.match(timeRegex);

    return match && match.length > 0;
  }

  validateTime() {
    const validateText = this.timeRules
      .map(item => item(this.jam))
      .find(item => item !== true);

    if (typeof validateText === "string") {
      appModule.sendErrorAlert(validateText);
      return false;
    }

    return true;
  }
}
